import { Link } from 'components/Link';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routes } from 'router/routes';

export const Footer = (): JSX.Element => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="bg-cream-50 max-w-[100vw]" data-testid="footer">
      <footer className="text-center mb-80 mt-40 text-black-600 text-sm font-semibold">
        <div className="hidden sm:flex flex-wrap justify-center space-x-20">
          <p>
            &copy; {new Date().getFullYear()} {t('footer.expressable')}
          </p>
          <Link
            to={`https://www.expressable.com/terms-and-conditions`}
            disableExternalLinkIcon
            className="hover:underline hover:text-black-900"
          >
            {t('footer.termsAndConditions')}
          </Link>
          <Link
            to={`https://www.expressable.com/privacy-policy`}
            disableExternalLinkIcon
            className="hover:underline hover:text-black-900"
          >
            {t('footer.privacyPolicy')}
          </Link>
          <Link
            target="_blank"
            to={routes.licenses}
            disableExternalLinkIcon
            className={`hover:underline hover:text-black-900 ${
              location.pathname === '/licenses' ? 'underline text-black-900' : ''
            }`}
          >
            {t('footer.licenses')}
          </Link>
          <Link
            to={`https://www.expressable.com/accessibility-statement`}
            disableExternalLinkIcon
            className="hover:underline hover:text-black-900"
          >
            {t('footer.accessibilityStatement')}
          </Link>
        </div>

        <div className="block sm:hidden mt-10">
          <div className="flex flex-wrap justify-center space-x-20 mb-2">
            <Link
              to={`https://www.expressable.com/terms-and-conditions`}
              disableExternalLinkIcon
              className="hover:underline hover:text-black-900"
            >
              {t('footer.termsAndConditions')}
            </Link>
            <Link
              to={`https://www.expressable.com/privacy-policy`}
              disableExternalLinkIcon
              className="hover:underline hover:text-black-900"
            >
              {t('footer.privacyPolicy')}
            </Link>
            <Link
              target="_blank"
              to={routes.licenses}
              disableExternalLinkIcon
              className={`hover:underline hover:text-black-900 ${
                location.pathname === '/licenses' ? 'underline text-black-900 ' : ''
              }`}
            >
              {t('footer.licenses')}
            </Link>
          </div>
          <div className="flex justify-center mb-2">
            <Link
              to={`https://www.expressable.com/accessibility-statement`}
              disableExternalLinkIcon
              className="hover:underline hover:text-black-900"
            >
              {t('footer.accessibilityStatement')}
            </Link>
          </div>
          <div className="flex justify-center mt-6">
            <p>
              &copy; {new Date().getFullYear()} {t('footer.expressable')}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};
